import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

interface PasswordInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  style?: React.CSSProperties;
  required?: boolean;
  id?: string;
  dir?: 'ltr' | 'rtl';
  autoComplete?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  value,
  onChange,
  placeholder,
  style,
  required,
  id,
  dir,
  autoComplete = 'current-password',
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isRTL = dir === 'rtl';
  const EyeIcon = AiOutlineEye as any;
  const EyeOffIcon = AiOutlineEyeInvisible as any;

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        id={id}
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        dir={dir}
        autoComplete={autoComplete}
        data-lpignore="true"
        data-1p-ignore
        style={{
          ...style,
          [isRTL ? 'paddingLeft' : 'paddingRight']: '44px',
          width: '100%',
          boxSizing: 'border-box',
        }}
      />
      <button
        type="button"
        onClick={() => setShowPassword(p => !p)}
        style={{
          position: 'absolute',
          [isRTL ? 'left' : 'right']: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#6b7280',
          fontSize: '18px',
          transition: 'color 0.2s ease',
          outline: 'none',
        }}
        onMouseOver={(e) => { e.currentTarget.style.color = '#374151'; }}
        onMouseOut={(e) => { e.currentTarget.style.color = '#6b7280'; }}
        aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
      >
        {showPassword
          ? <EyeOffIcon size={20} />
          : <EyeIcon size={20} />
        }
      </button>
    </div>
  );
};

export default PasswordInput;

